import { render } from "./TextSetting.vue?vue&type=template&id=20d2c52e&scoped=true"
import script from "./TextSetting.vue?vue&type=script&lang=ts"
export * from "./TextSetting.vue?vue&type=script&lang=ts"

import "./TextSetting.vue?vue&type=style&index=0&id=20d2c52e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20d2c52e"

export default script